import { render, staticRenderFns } from "./CompanyCommission.vue?vue&type=template&id=c1e51b90"
import script from "./CompanyCommission.vue?vue&type=script&lang=js"
export * from "./CompanyCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports